/*
 * The computation API identifies every serialized entity (pumps, tubes, cups,
 * handled objects, …) by a numeric id allocated from this fixed pool. The pool
 * is a hard protocol limit: once it is exhausted, `serializeStateToRequest`
 * throws "Not enough IDs".
 *
 * Each cardboard box consumes one id, which is why `maxBoxesPerPattern` in
 * `3d/pallet-patterns.ts` is derived from this constant — raise or lower one
 * and the other follows.
 */
export var computationApiIdPoolSize = 255;
